import {
  faInfoCircle,
  faExclamationTriangle,
  faCheckCircle,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { Flex } from '@pinchenterprisesnpm/friday-ui'
import { CustomBannerContainer, CustomBannerText } from './info-banner.styles'

type BannerVariant = 'primary' | 'warning' | 'success'

interface IInfoBannerProps {
  description: string
  variant?: BannerVariant
  icon?: IconDefinition
  marginLeft?: string
  marginRight?: string
  marginTop?: string
  marginBottom?: string
  textVariant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'small'
    | 'default'
    | 'medium'
    | 'xxsmall'
    | 'xsmall'
    | 'large'
}

const getBannerConfig = (variant: BannerVariant) => {
  switch (variant) {
    case 'primary':
      return {
        backgroundColor: '#E8F6FC',
        textColor: '#02557A',
        iconColor: '#02557A',
        defaultIcon: faInfoCircle,
      }
    case 'warning':
      return {
        backgroundColor: '#FCD6B0',
        textColor: '#874400',
        iconColor: '#874400',
        defaultIcon: faExclamationTriangle,
      }
    case 'success':
      return {
        backgroundColor: '#00800008',
        textColor: '#008000',
        iconColor: '#008000',
        defaultIcon: faCheckCircle,
      }
    default:
      return {
        backgroundColor: '#E8F6FC',
        textColor: '#02557A',
        iconColor: '#02557A',
        defaultIcon: faInfoCircle,
      }
  }
}

export const InfoBanner = ({
  description,
  variant = 'primary',
  icon,
  marginLeft = '10px',
  marginRight = '10px',
  marginTop = '10px',
  marginBottom = '10px',
  textVariant = 'medium',
}: IInfoBannerProps) => {
  const config = getBannerConfig(variant)
  const bannerIcon = config.defaultIcon || icon

  return (
    <CustomBannerContainer
      backgroundColor={config.backgroundColor}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      marginBottom={marginBottom}
    >
      <Flex alignItems="center" p={10}>
        <FontAwesomeIcon icon={bannerIcon} size="lg" color={config.iconColor} />
        <CustomBannerText
          textColor={config.textColor}
          variant={textVariant}
          ml={10}
        >
          {description}
        </CustomBannerText>
      </Flex>
    </CustomBannerContainer>
  )
}
